import { useState } from "react";
import ModalComponent from "../../../../components/UI/Modal";
import { Stack, Typography } from "@mui/material";
import { Button } from "@4uhub/lib4uhub";
import { useTranslation } from "react-i18next";
import InfoIcon from "@mui/icons-material/Info";
import OrientationCard from "../../NewSchedule/Steps/Confirm/OrientationCard";

export interface IOrientationItem {
  title: string;
  content: string;
}

interface IOrientationsProps {
  orientations: IOrientationItem[];
}

const TRASNLATION_PATH = "page.schedules.scheduleDetails.";

export const Orientations = ({ orientations }: IOrientationsProps) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  if (!orientations.length) return null;

  const closeHandler = () => setOpen(false);

  const openHandler = () => setOpen(true);

  return (
    <>
      <ModalComponent open={open} onClose={closeHandler} dialogMaxWidth="xl">
        <Stack gap={2}>
          <Typography variant="h6" fontWeight="bold">
            {t(TRASNLATION_PATH + "orientations")}
          </Typography>

          <Stack gap={2}>
            {orientations.map(({ title, content }, index) => (
              <OrientationCard key={index} title={title} content={content} />
            ))}
          </Stack>
        </Stack>
      </ModalComponent>

      <Button
        variant="contained"
        onClick={openHandler}
        sx={{
          width: { xs: "100%", md: "auto" },
          gap: 1,
          textTransform: "none",
          py: 1.5,
        }}
      >
        <InfoIcon />

        <Typography>{t(TRASNLATION_PATH + "see_orientations")}</Typography>
      </Button>
    </>
  );
};
